import { NextRouter } from 'next/router';

import { RN_MESSAGE_TYPES } from './constants';
import { postMessageToApp } from './window.util';

interface BarcodeScannerNavigationOptions {
  router: NextRouter;
  shouldHandle: boolean;
  screenToNavigate: string | string[] | undefined;
}

export function navigateBarcodeScanner({
  router,
  shouldHandle,
  screenToNavigate,
}: BarcodeScannerNavigationOptions): boolean {
  if (!shouldHandle) return false;

  const isSameQuery = router.query.q === router.query.barcodeQuery;
  const hasNavigateToScreen = !!router.query.navigateToScreen;

  if (isSameQuery) {
    postMessageToApp({
      type: RN_MESSAGE_TYPES.OPEN_BARCODE_SCANNER,
      data: { screen: screenToNavigate },
    });
    return true;
  }

  if (hasNavigateToScreen && !isSameQuery) {
    router.back();
    return true;
  }

  return false;
}
